import { PropsWithChildren } from "react";
import { IS_PLAYWRIGHT } from "@util/constant";
import {
  useFeatureFlagEnabled,
  useFeatureFlagVariantKey,
} from "posthog-js/react";

type PosthogFeatureProps = {
  /** The unique name of the feature flag. */
  flagName: string;
  /** The variant key to be used for the feature flag. */
  variantKey?: string;
} & PropsWithChildren;

/** Main component to use in place of PostHogFeature from posthog-js/react */
export default function PosthogFeature({
  flagName,
  children,
  variantKey,
}: PosthogFeatureProps): React.ReactElement {
  const flag = useFeatureFlagEnabled(flagName);
  const variant = useFeatureFlagVariantKey(flagName);

  // Always enable the feature flag in Playwright tests.
  if (IS_PLAYWRIGHT) return <>{children}</>;
  // If the feature flag is not enabled, dont render anything.
  if (!flag) return <></>;

  // If a variant key is provided, check if the variant is the same as the variant key.
  if (typeof variantKey === "string") {
    return <>{variantKey === variant ? children : null}</>;
  }

  // If no variant key is provided, render the children.
  return <>{children}</>;
}
